$(function () {
  const $langSwitcher = $('.lang-switcher');
  if ($langSwitcher.length <= 0) return;

  $langSwitcher.on('click', function () {
    $(this).toggleClass('open');
  });

  const $activeLang = $langSwitcher.find('.lang-switcher__active-lang');
  if ($activeLang.length <= 0) return;

  $activeLang.on('blur', function (e) {
    if (!e.relatedTarget || !e.relatedTarget.closest('.lang-switcher__dropdown')) {
      $langSwitcher.removeClass('open');
    }
  });
});
